export const convertToDate = (resultDate) => {
  const yyyy = resultDate.getFullYear()
  let mm = resultDate.getMonth()
  let dd = resultDate.getDate()
  mm = mm + 1
  if (dd < 10) dd = '0' + dd
  if (mm < 10) mm = '0' + mm
  return yyyy + '-' + mm + '-' + dd + 'T00:00:00.000Z'
}

/** yyyy-MM-dd for query params such as ?dt=2025-05-28 */
export const formatQueryDate = (date) => {
  return new Date(date).toLocaleDateString('en-CA')
}

export const getToday = () => new Date()

export const shiftCalendarMonths = (date, amount) => {
  const source = new Date(date)
  const day = source.getDate()
  const result = new Date(source)
  result.setDate(1)
  result.setMonth(result.getMonth() + amount)
  const lastDay = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate()
  result.setDate(Math.min(day, lastDay))
  return result
}

export const isValidDateRange = (beginDate, endDate) => {
  const begin = new Date(beginDate)
  const end = new Date(endDate)
  return !Number.isNaN(begin.getTime()) && !Number.isNaN(end.getTime()) && begin <= end
}

export const isDateRangeWithinOneMonth = (beginDate, endDate) => {
  if (!isValidDateRange(beginDate, endDate)) return false
  return new Date(endDate) <= shiftCalendarMonths(beginDate, 1)
}

export const getRecentCalendarMonthRange = () => {
  const end = new Date()
  end.setDate(end.getDate() + 1)
  end.setHours(0, 0, 0, 0)
  return {
    begin: shiftCalendarMonths(end, -1),
    end,
  }
}
